import { useLanguage } from '../context/LanguageContext';
import { Rocket, Award, Globe2 } from 'lucide-react';

export const ValuesSection = () => {
  const { t } = useLanguage();

  const values = [
    {
      key: 'entrepreneurship',
      icon: Rocket,
      color: '#4caf50'
    },
    {
      key: 'excellence',
      icon: Award,
      color: '#004d40'
    },
    {
      key: 'connection',
      icon: Globe2,
      color: '#907b89'
    }
  ];

  return (
    <section className="section-padding bg-[#f8fafc]" data-testid="values-section">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            className="font-serif text-4xl md:text-5xl font-bold text-[#004d40] mb-4"
            data-testid="values-title"
          >
            {t('values.title')}
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            {t('values.subtitle')}
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={value.key}
                className="bg-white rounded-2xl p-8 card-hover border border-slate-100"
                style={{ 
                  animationDelay: `${index * 0.15}s`,
                  opacity: 1
                }}
                data-testid={`value-card-${value.key}`}
              >
                {/* Icon */}
                <div 
                  className="value-icon"
                  style={{ background: `linear-gradient(135deg, ${value.color}15, ${value.color}08)` }}
                >
                  <Icon 
                    className="w-8 h-8"
                    style={{ color: value.color }}
                  />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-[#004d40] mb-3">
                  {t(`values.${value.key}.title`)}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {t(`values.${value.key}.desc`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
